import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import moment from 'moment-timezone';
import zoomPlugin from 'chartjs-plugin-zoom';

import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Legend,
  Filler,
  TimeScale,
  TimeSeriesScale,
  Tooltip

} from 'chart.js';

Chart.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Legend,
  Filler,
  TimeScale,
  TimeSeriesScale,
  Tooltip,
  zoomPlugin,


);
Chart.defaults.font.family = "'Arial', 'sans-serif'";
Chart.defaults.font.weight = 600;


export const LineChartReport = ({ name, datasets, labels, yMin, yMax, powerTensionNominal }) => {

  const options = {
    type: 'line',
    maintainAspectRatio: false,
    responsive: true,
    animation: false,
    aspectRatio: 1,
    showTooltips: true,
    elements: {
      point: {
        radius: 0,
      }
    },
    transitions: {
      zoom: {
        animation: {
          duration: 0
        }
      }
    },
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: 'rgb(255,255,255)',
        titleColor: 'rgb(0,0,0)',
        bodyColor: '#000000',
        caretPadding: 100,
        position: 'nearest',
        usePointStyle: true,
        borderColor: 'rgb(106, 106, 106)',
        borderWidth: 0.5,
        callbacks: {
          title: function (context) {

            const formattedDate = moment(context[0].label, "MMM DD, YYYY, h:mm:ss a").format("DD/MM/YY HH:mm:ss");
            return formattedDate;
          },
          label: function (context) {

            if (context.dataset.label === "Porta Fechada" || context.dataset.label === "Ignição Ligada (I)" || context.dataset.label === "Climatização (C)") {
              context.formattedValue = "";
            }
            else if (context.formattedValue.includes('.')) {

            } else {
              const value = parseFloat(context.formattedValue.replace(',', '.'));
              const formattedValue = isNaN(value) ? context.formattedValue : value.toFixed(2);

              if (context.dataset.label === "") {
                context.formattedValue = formattedValue;
              } else if (context.formattedValue.length < 7) {
                context.formattedValue = formattedValue;
              }
            }

          }
        }

      },
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 16
          },
          generateLabels: function (chart) {
            const defaultLabels = Chart.defaults.plugins.legend.labels.generateLabels(chart);
            const updatedLabels = defaultLabels.map(label => {
              if (label.text === '') {
                label.lineCap = 'butt';
                label.fillStyle = 'rgba(0, 0, 0, 0)';
                label.lineWidth = 0;
                label.onClick = () => { };
              } else {
                label.padding = 10;
                label.textAlign = 'center';
                label.textBaseline = 'middle';
                label.fontColor = 'black';
              }
              return label;
            });
            return updatedLabels;
          }
        }
      },
      title: {
        display: false,
      },
      zoom: {
        enabled: name === "ThermoKing" ? false : true,
        mode: 'xy',
        zoom: {
          wheel: {
            enabled: name === "ThermoKing" ? false : true,
          },
          pinch: {
            enabled: name === "ThermoKing" ? false : true,
          },
          drag: {
            enabled: name === "ThermoKing" ? false : true,
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgb(255, 99, 132)',
            borderWidth: 1,
            modifierKey: 'ctrl'
          },
        },

      }

    },
    hover: {
      mode: "nearest",
      intersect: true,
    },
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        type: 'time',
        time: {

          unit: 'minute',

        },
        border: {
          display: false
        },
        grid: {
          display: true,
          drawOnChartArea: true,
          drawTicks: true,
          offset: false,
          lineWidth: 0.1,
          color: 'rgba(0, 0, 0, 0.5)'
        },
        ticks: {

          color: "rgb(0, 0, 0)",
          font: {
            size: 12
          },
          stepSize: 2,
          display: true,
          source: 'auto',
          maxRotation: 90,
          minRotation: 90,
          autoSkip: true,
          callback: (value, index, values) => {
            const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
            return formattedDate;
          },
        },
      },
      y: {
        type: 'linear',
        display: true,
        position: 'left',
        grid: {
          display: false,
          drawOnChartArea: true,
          drawTicks: true,
          offset: false,
          lineWidth: 0.5,
          color: 'rgba(0, 0, 0, 0.5)'
        },
        border: {
          display: true,
        },
        min: name === "PowerTension" && powerTensionNominal === "24" ? 15 : 0,
        max: name === 'ThermoKing' ? 200 : name === 'temperature' ? 45 : name === 'humidity' ? 110 : name === 'co2' ? 5000 : name === "PowerTension" && powerTensionNominal === "12" ? 25 : name === "PowerTension" && powerTensionNominal === "24" ? 40 : 3,
        ticks: {
          color: "black",
          stepSize: name === 'ThermoKing' ? 20 : name === 'temperature' ? 5 : name === 'humidity' ? 10 : name === 'co2' ? 500 : name === "PowerTension" && powerTensionNominal === "12" ? 5 : name === "PowerTension" && powerTensionNominal === "24" ? 5 : 0.5,
          font: {
            size: 14,
          },

          callback: function (value, index) {
            if (name !== "ThermoKing") {
              if (name === 'co2') {
                return value.toLocaleString('pt-BR', { minimumFractionDigits: 0 }) + "  ";
              } else if (name === "temperature") {
                return value.toLocaleString('pt-BR', { minimumFractionDigits: 0 }) + "      ";
              } else if (name === "humidity") {
                return value.toLocaleString('pt-BR', { minimumFractionDigits: 0 }) + "    ";
              } else if (name === "mechnical-vibrations") {
                return value.toLocaleString('pt-BR', { minimumFractionDigits: 1 }) + "    ";
              } else if (name === "PowerTension" && powerTensionNominal === "12") {
                return value === 25 ? " " : value.toLocaleString('pt-BR', { minimumFractionDigits: 0 });
              } else if (name === "PowerTension" && powerTensionNominal === "24") {
                return value === 40 ? " " : value.toLocaleString('pt-BR', { minimumFractionDigits: 0 });
              }
              return value.toLocaleString('pt-BR', { minimumFractionDigits: 0 });
            } else {
              return index * 20 + "  ";
            }
          }
        },
      },
      y1: {
        display: true,
        position: 'right',
        type: 'linear',
        min: name === "PowerTension" ? 0 : yMin,
        max: name === "PowerTension" ? 21 : yMax,

        grid: {
          display: false,
          drawOnChartArea: true,
          drawTicks: true,
          offset: false,
          lineWidth: 0.5,
          color: 'rgba(0, 0, 0, 0.5)'
        },

        border: {
          display: false,
        },

        ticks: {
          callback: function (value, index) {

            if (name === "ThermoKing") {
              return (index * 20) === 180 ? "C" : (index * 20) === 160 ? "I" : (index * 20) === 140 ? "P" : " ";
            }
            else if (name === "PowerTension") {
              return index === 20 ? "I" : " ";
            }
          },
          stepSize: name === "PowerTension" ? 1 : 0,
          color: "black",
          font: {
            size: 12
          },
        },
      }
    },
  };

  const data = {
    labels: labels,
    datasets: datasets,
  };

  return (
    <Line id={`canvaID${name}`} options={options} data={data} />
  );
}